<script>
  import { animate } from 'animejs'

  import { getContext, onMount } from 'svelte'
  import Container from '~/components/ui/container.svelte'

  const page = getContext('portfolio_page')

  onMount(() => {
    animate('.headline-animation .el-animated', {
      rotateX: [90, 0],
      duration: 1 * 1000,
    })
  })
</script>

<section>
  <Container>
    <div class="headline-animation min-h-[30vh] lg:h-auto lg:border-l-2 lg:border-gray-300 lg:px-8">
      <h1 class="el-animated mb-6 text-4xl lg:w-1/3 lg:text-7xl">{page.title}</h1>
      <p class="el-animated text-md lg:w-8/12">
        {page.description}
      </p>
    </div>

    <hr class="my-[48px]" />
  </Container>
</section>
